import { IconAvatar } from "../assets/icons";
import Header from "./Header";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFromRoute } from "../redux/navigation.slice";
import routes from "../routing/routes";
import { useNavigate } from "react-router-dom";
import useParamNavigation from "../utils/navigation";
import { useTranslation } from "react-i18next";
import BackButtonNavigation from "./BackButtonNavigation";
import SecureImage from "./SecureImage";

export const Avatar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathWithPropId } = useParamNavigation();

  const { valuations, currentValuation } = useSelector(
    (store) => store.valuationsDetails
  );

  const handleOpenMenu = () => {
    dispatch(
      setFromRoute({ menu: routes["main-shell"].children["home"].path })
    );
    navigate(pathWithPropId(routes["main-shell"].children["menu"].path));
  };

  return valuations[currentValuation]?.userProfile?.photo ? (
    <SecureImage src={valuations[currentValuation]?.userProfile?.photo}>
      {(imageSrc) => (
        <img
          className="w-8 h-8 rounded-full cursor-pointer"
          src={imageSrc || "/images/placeholder.png"}
          alt="user-img"
          onClick={handleOpenMenu}
        />
      )}
    </SecureImage>
  ) : (
    <img
      src={IconAvatar}
      alt="icon-avatar"
      className="rounded-full w-8 h-8 self-center cursor-pointer"
      onClick={handleOpenMenu}
    />
  );
};

export const TitleHeader = ({
  title,
  subtitle,
  hasAvatar = true,
  handleBack = null
}) => {
  const { t } = useTranslation();
  const [showNotificationAlert] = useState(true);

  const { valuations, currentValuation } = useSelector(
    (store) => store.valuationsDetails
  );

  return (
    <Header
      className="fixed top-0"
      showNotificationAlert={showNotificationAlert}
      burgerAction={true}
    >
      <div className="flex gap-5 items-center">
        {handleBack && <BackButtonNavigation onClick={handleBack} />}
        {hasAvatar && <Avatar />}
        <div>
          <div className="font-bold text-accumin-neutral-500">
            {title ??
              (valuations[currentValuation]?.userProfile?.firstName
                ? t("homepage.title-with-name", {
                    name: valuations[currentValuation]?.userProfile?.firstName
                  })
                : t("homepage.title"))}
          </div>
          <div className="text-xs font-medium text-accumin-neutral-400">
            {subtitle ?? t("homepage.subtitle")}
          </div>
        </div>
      </div>
    </Header>
  );
};
